import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { Feature, SellerAccountClient } from 'src/WebApiController';

export function useGetCustomPaymentTypesQuery(
  paymentContext: 'Sale' | 'PO' = 'Sale'
) {
  const { activeAccountWebClientConfig } = useAppContext();
  const { trackError } = useClientLogContext();
  const hasFeature = useUserHasFeature(Feature.CustomExternalPaymentTypes);

  const shouldQuery =
    hasFeature && activeAccountWebClientConfig.activeAccountId != null;

  return useQuery({
    queryKey: [
      'getCustomPaymentTypes',
      activeAccountWebClientConfig.activeAccountId,
      paymentContext,
    ],
    queryFn: () => {
      if (!shouldQuery) return null;
      return new SellerAccountClient(
        activeAccountWebClientConfig
      ).getCustomPaymentTypes(paymentContext);
    },
    enabled: shouldQuery,
    refetchOnWindowFocus: false,
    meta: {
      onError: (error: ErrorTypes) => {
        trackError('SellerAccountClient.getCustomPaymentTypes', error);
      },
    },
  });
}
